module.exports = __webpack_public_path__ + "img/debtia.48fecc6c.svg";